import { Theme } from "@mui/material/styles";
import LottieUtils from "./lottie_utils";

export const progressLottieOptions = (
  theme: Theme,
  animation: any,
  customColor?: string
) => {
  const primaryColor = customColor || theme.vars.palette.primary.main;
  let overrideAnimationData = null;
  const colors = LottieUtils.getAllColors(animation);
  overrideAnimationData = LottieUtils.replaceColors(
    animation,
    Object.fromEntries(colors.map((color) => [color, primaryColor]))
  );

  return {
    loop: true,
    autoplay: true,
    animationData: theme.dtcMode ? overrideAnimationData : animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};
